module.exports = __webpack_public_path__ + "static/media/reachedTournamentTop10_3_5.21b9c2cd.png";